module.exports = __webpack_public_path__ + "static/media/old1 spw-global-high-quality.dd62eb17.csv";